export default "__VITE_ASSET__1e557e00__"